import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/outline"
import { Accordion, AccordionBody, AccordionHeader, Card, List, ListItem, ListItemPrefix, Typography } from "@material-tailwind/react"
import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import "./../css/output.css"
import "./../js/scroll.js"

import commonJson from "./../json/common.json"
import displayJson from "./../json/display.json"
import eventJson from "./../json/event.json"
import goodsJson from "./../json/goods.json"
import memberJson from "./../json/member.json"
import orderJson from "./../json/order.json"

const commonjs = require("./../js/common.js")

export const CommomnData = () => {
	return commonJson
}
export const DisplayData = () => {
	return displayJson
}
export const EventData = () => {
	return eventJson
}
export const GoodsData = () => {
	return goodsJson
}
export const MemberData = () => {
	return memberJson
}
export const OrderData = () => {
	return orderJson
}

const jp = require("jsonpath")

const Navi = (modulsName) => {
	const [data, setData] = useState(null) // 데이터 상태
	useEffect(() => {
		async function fetchData(modulsName) {
			let jsonData
			switch (modulsName) {
				case "common":
					jsonData = CommomnData()
					break
				case "display":
					jsonData = DisplayData()
					break
				case "event":
					jsonData = EventData()
					break
				case "goods":
					jsonData = GoodsData()
					break
				case "member":
					jsonData = MemberData()
					break
				case "order":
					jsonData = OrderData()
					break
				default:
					jsonData = ""
					break
			}
			const names = jp.query(jsonData, "$..paths")
			const result = Object.entries(
				jp.nodes(names, "$..tags").reduce((acc, { path, value, group }) => {
					let names = value.toString()
					let paths = path[2].toString()
					acc[names] = acc[names] || []
					acc[names].push({ names, paths })
					return acc
				}, {})
			).map(([key, value]) => ({ name: key, path: value }))
			setData(result)
		}
		fetchData(modulsName) // 데이터를 가져오는 함수 호출
	}, []) // 빈 배열을 전달하여 컴포넌트가 마운트될 때 한 번만 실행
	return data
}

const OpenIndex = (modulsName) => {
	switch (modulsName) {
		case "common":
			return 1
		case "display":
			return 2
		case "event":
			return 3
		case "goods":
			return 4
		case "member":
			return 5
		case "order":
			return 6
		default:
			return 0
	}
}

const Sidebar = () => {
	const handleOpen = (value) => {
		commonjs.OpenRequest(true)
		setOpen(open === value ? 0 : value)
	}
	let [open, setOpen] = React.useState(0)
	const commonNavi = Navi("common")
	const displayNavi = Navi("display")
	const eventNavi = Navi("event")
	const goodsNavi = Navi("goods")
	const memberNavi = Navi("member")
	const orderNavi = Navi("order")
	const navigate = useNavigate()
	const handleLink = (param, depth, index) => {
		navigate("/content?msa=" + param + "&depth=" + depth)
	}

	const windowUrl = window.location.search
	const params = new URLSearchParams(windowUrl)
	const msa = params.get("msa") == null ? "" : params.get("msa").replace(/[0-9]/g, "")
	if (msa != null && !commonjs.SideBarRequestHandler()) {
		open = OpenIndex(msa)
	}

	return (
		<div className="lnb overflow-y-auto bg-white">
			<Card className="border_0 shadow left-0 z-30 flex shaflex-col w-64 text-gray-700 transition duration-300 ease-out transform translate-x-0 bg-white border-r-2 bg-clip-border lg:translate-x-0 lg:static">
				{/* 리스트 */}
				<List>
					<ListItem>
						<div className="theme">
							<svg className="h-6 w-6" viewBox="0 0 24 24" fill="none">
								<path d="M6 8a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8ZM6 15a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-1Z" className="fill-purple-400 group-hover:fill-purple-500 dark:group-hover:fill-purple-300 dark:fill-slate-600"></path>
								<path d="M13 8a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2V8Z" className="fill-purple-200 group-hover:fill-purple-300 dark:group-hover:fill-white dark:fill-slate-400"></path>
								<path d="M13 15a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-1Z" className="fill-purple-400 group-hover:fill-purple-500 dark:group-hover:fill-purple-300 dark:fill-slate-600"></path>
							</svg>
							<Link to="/">
								<span>FO API summary</span>
							</Link>
						</div>
					</ListItem>

					<Accordion open={open === 1} icon={<ChevronDownIcon strokeWidth={2.5} className={`mx-auto h-4 w-4 transition-transform ${open === 1 ? "rotate-180" : ""}`} />}>
						<ListItem className="p-0" selected={open === 1}>
							<AccordionHeader onClick={() => handleOpen(1)} className="border-b-0 p-3">
								<Typography className="mr-auto font-normal lnb_font">Common</Typography>
							</AccordionHeader>
						</ListItem>
						<AccordionBody className="py-1">
							<List className="p-0 lnb_depth1">
								{commonNavi != null &&
									commonNavi.map((item, index) => (
										<ListItem className="lnb_depth2" key={item.name} nav-tag={item.name.replaceAll(" ", "_")} onClick={handleLink.bind(null, "common", item.name, index)}>
											{item.name}
										</ListItem>
									))}
							</List>
						</AccordionBody>
					</Accordion>

					{/* Display */}
					<Accordion open={open === 2} icon={<ChevronDownIcon strokeWidth={2.5} className={`mx-auto h-4 w-4 transition-transform ${open === 2 ? "rotate-180" : ""}`} />}>
						<ListItem className="p-0" selected={open === 2}>
							<AccordionHeader onClick={() => handleOpen(2)} className="border-b-0 p-3">
								<Typography className="mr-auto font-normal lnb_font">Display</Typography>
							</AccordionHeader>
						</ListItem>
						<AccordionBody className="py-1">
							<List className="p-0 lnb_depth1">
								{displayNavi != null &&
									displayNavi.map((item, index) => (
										<ListItem className="lnb_depth2" key={item.name} nav-tag={item.name.replaceAll(" ", "_")} onClick={handleLink.bind(null, "display", item.name, index)}>
											{item.name}
										</ListItem>
									))}
							</List>
						</AccordionBody>
					</Accordion>

					{/* Event */}
					<Accordion open={open === 3} icon={<ChevronDownIcon strokeWidth={2.5} className={`mx-auto h-4 w-4 transition-transform ${open === 3 ? "rotate-180" : ""}`} />}>
						<ListItem className="p-0" selected={open === 3}>
							<AccordionHeader onClick={() => handleOpen(3)} className="border-b-0 p-3">
								<Typography className="mr-auto font-normal lnb_font">Event</Typography>
							</AccordionHeader>
						</ListItem>
						<AccordionBody className="py-1">
							<List className="p-0 lnb_depth1">
								{eventNavi != null &&
									eventNavi.map((item, index) => (
										<ListItem className="lnb_depth2" key={item.name} nav-tag={item.name.replaceAll(" ", "_")} onClick={handleLink.bind(null, "event", item.name, index)}>
											{item.name}
										</ListItem>
									))}
							</List>
						</AccordionBody>
					</Accordion>

					{/* Goods */}
					<Accordion open={open === 4} icon={<ChevronDownIcon strokeWidth={2.5} className={`mx-auto h-4 w-4 transition-transform ${open === 4 ? "rotate-180" : ""}`} />}>
						<ListItem className="p-0" selected={open === 4}>
							<AccordionHeader onClick={() => handleOpen(4)} className="border-b-0 p-3">
								<Typography className="mr-auto font-normal lnb_font">Goods</Typography>
							</AccordionHeader>
						</ListItem>
						<AccordionBody className="py-1">
							<List className="p-0 lnb_depth1">
								{goodsNavi != null &&
									goodsNavi.map((item, index) => (
										<ListItem className="lnb_depth2" key={item.name} nav-tag={item.name.replaceAll(" ", "_")} onClick={handleLink.bind(null, "goods", item.name, index)}>
											{item.name}
										</ListItem>
									))}
							</List>
						</AccordionBody>
					</Accordion>

					{/* Member */}
					<Accordion open={open === 5} icon={<ChevronDownIcon strokeWidth={2.5} className={`mx-auto h-4 w-4 transition-transform ${open === 5 ? "rotate-180" : ""}`} />}>
						<ListItem className="p-0" selected={open === 5}>
							<AccordionHeader onClick={() => handleOpen(5)} className="border-b-0 p-3">
								<Typography className="mr-auto font-normal lnb_font">Member</Typography>
							</AccordionHeader>
						</ListItem>
						<AccordionBody className="py-1">
							<List className="p-0 lnb_depth1">
								{memberNavi != null &&
									memberNavi.map((item, index) => (
										<ListItem className="lnb_depth2" key={item.name} nav-tag={item.name.replaceAll(" ", "_")} onClick={handleLink.bind(null, "member", item.name, index)}>
											{item.name}
										</ListItem>
									))}
							</List>
						</AccordionBody>
					</Accordion>

					{/* Order */}
					<Accordion open={open === 6} icon={<ChevronDownIcon strokeWidth={2.5} className={`mx-auto h-4 w-4 transition-transform ${open === 6 ? "rotate-180" : ""}`} />}>
						<ListItem className="p-0" selected={open === 6}>
							<AccordionHeader onClick={() => handleOpen(6)} className="border-b-0 p-3">
								<Typography className="mr-auto font-normal lnb_font">Order</Typography>
							</AccordionHeader>
						</ListItem>
						<AccordionBody className="py-1">
							<List className="p-0 lnb_depth1">
								{orderNavi != null &&
									orderNavi.map((item, index) => (
										<ListItem className="lnb_depth2" key={item.name} nav-tag={item.name.replaceAll(" ", "_")} onClick={handleLink.bind(null, "order", item.name, index)}>
											{item.name}
										</ListItem>
									))}
							</List>
						</AccordionBody>
					</Accordion>
				</List>
			</Card>
		</div>
	)
}

export default Sidebar
